import { DoubleSide, MeshPhysicalMaterial } from "three";

export const WaterMaterial = async (color: number) => {
	return new MeshPhysicalMaterial({
		color: color,
		emissive: 0xaaaaaa,
		emissiveIntensity: 0.1,

		transparent: true,
		side: DoubleSide,
		metalness: 0,
		opacity: 0.9,

		roughness: 0.45,
		ior: 1.5,
		reflectivity: 1,
		clearcoat: 1,
		clearcoatRoughness: 0,
		iridescence: 1,
		iridescenceIOR: 0.96,
		sheen: 1,
		sheenRoughness: 0,
		transmission: 1,
		thickness: 1,
	});
};
